<div class="card">
  <app-payment-otd [InputConfig]="config"></app-payment-otd>
</div>